import {
  FETCH_RATE_LOADING,
  FETCH_RATE_DONE,
  FETCH_RATE_ERROR,
  FETCH_RATE_DETAIL_LOADING,
  FETCH_RATE_DETAIL_DONE,
  FETCH_RATE_DETAIL_ERROR,
  POST_RATE_LOADING,
  POST_RATE_DONE,
  POST_RATE_ERROR,
  FETCH_DASHBOARD_RATE_LOADING,
  FETCH_DASHBOARD_RATE_DONE,
  FETCH_DASHBOARD_RATE_ERROR,
  PUT_SKIP_RATE_LOADING,
  PUT_SKIP_RATE_DONE,
  PUT_SKIP_RATE_ERROR
} from './actions'

export default {
  [FETCH_RATE_LOADING] (state) {
    state.isLoadingRate = true
    state.errorRate = false
  },

  [FETCH_RATE_DONE] (state, items) {
    state.rate = items
    state.isLoadingRate = false
    state.errorRate = false
  },

  [FETCH_RATE_ERROR] (state, error) {
    state.isLoadingRate = false
    state.errorRate = error
  },

  [FETCH_RATE_DETAIL_LOADING] (state) {
    state.isLoadingRateDetail = true
    state.errorRateDetail = false
  },

  [FETCH_RATE_DETAIL_DONE] (state, items) {
    state.rateDetail = items
    state.isLoadingRateDetail = false
    state.errorRateDetail = false
  },

  [FETCH_RATE_DETAIL_ERROR] (state, error) {
    state.isLoadingRateDetail = false
    state.errorRateDetail = error
  },

  [POST_RATE_LOADING] (state) {
    state.errorPostRate = true
    state.isLoadingPostRate = false
  },

  [POST_RATE_DONE] (state, items) {
    state.postRate = items
    state.isLoadingPostRate = false
    state.errorPostRate = false
  },

  [POST_RATE_ERROR] (state, error) {
    state.errorPostRate = error
    state.isLoadingPostRate = false
  },

  [FETCH_DASHBOARD_RATE_LOADING] (state) {
    state.isLoadingRateDashboard = true
    state.errorRateDashboard = false
  },

  [FETCH_DASHBOARD_RATE_DONE] (state, items) {
    state.rateDashboard = items
    state.isLoadingRateDashboard = false
    state.errorRateDashboard = false
  },

  [FETCH_DASHBOARD_RATE_ERROR] (state, error) {
    state.isLoadingRateDashboard = false
    state.errorRateDashboard = error
  },

  [PUT_SKIP_RATE_LOADING] (state) {
    state.isLoadingSkipRate = true
    state.errorSkipRate = false
  },

  [PUT_SKIP_RATE_DONE] (state, items) {
    state.skipRate = items
    state.isLoadingSkipRate = false
    state.errorSkipRate = false
  },

  [PUT_SKIP_RATE_ERROR] (state, error) {
    state.isLoadingSkipRate = false
    state.errorSkipRate = error
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rate/mutations.js